import { ColDef } from 'ag-grid-community';
import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { IncidentMapping } from '../../models/Mapping';
import { useMemo } from 'react';

interface MappingsAgGridTableProps {
  mappings: IncidentMapping[];
  columnDefs: ColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isFetching?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (
    sorting: { field: string; direction: 'asc' | 'desc' } | null
  ) => void;
}

export const MappingsAgGridTable = ({
  mappings,
  columnDefs,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isFetching,
  sorting,
  onSortingChange,
}: MappingsAgGridTableProps) => {
  const shouldDim = Boolean(isFetching && !isFetchingNextPage);

  // 🎯 Configuración personalizada para manejar filas con id null
  // Usar el índice del array como identificador cuando id es null para garantizar unicidad
  const gridOptions = useMemo(() => {
    // Crear un mapa de índices basado en la posición en el array
    const indexMap = new Map<IncidentMapping, number>();
    mappings.forEach((mapping, index) => {
      indexMap.set(mapping, index);
    });

    return {
      getRowId: (params: any) => {
        const mapping = params.data as IncidentMapping;
        // Si id existe, usarlo
        if (mapping.id !== null && mapping.id !== undefined) {
          return String(mapping.id);
        }
        // Si id es null, usar el índice del array como identificador único
        const index = indexMap.get(mapping) ?? params.node?.rowIndex ?? Math.random();
        return `mapping-null-${mapping.courier_incident_kind_id}-${index}`;
      },
    };
  }, [mappings]);

  return (
    <div
      className={`w-full transition-opacity duration-300 ${
        shouldDim ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      <AgGridTable
        data={mappings}
        columnDefs={columnDefs}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        enableSelection={false}
        sorting={sorting ?? null}
        onSortingChange={onSortingChange}
        className="rounded-lg shadow-sm"
        height="calc(100vh - 150px)"
        gridOptions={gridOptions}
      />
    </div>
  );
};
